import htmlTags from "html-tags";
import selfClosingTags from "html-tags/void";
import type { ReactNode } from "react";

const htmlHandler: { [tag: string]: (chunks: ReactNode[]) => string } =
  htmlTags.reduce((handlers, tag) => {
    return {
      ...handlers,
      [tag]: (chunks: ReactNode[]) => `<${tag}>${chunks.join("")}</${tag}>`,
    };
  }, {});
selfClosingTags.forEach((tag) => {
  htmlHandler[tag] = () => `<${tag}/>`;
});

export default htmlHandler;
